import { imageUrlBase } from "../constants"

// Put image urls here so you can load them all up via storybook and make sure they all exist at the url that will be called
export const imageUrls: { [key: string]: string } = {
  documentIcon: imageUrlBase + "/assets/document-icon.png",
  "trashcan@1x": imageUrlBase + "/assets/large-trash-can@1x.png",
  "trashcan@2x": imageUrlBase + "/assets/large-trash-can@2x.png",
  "trashcan@3x": imageUrlBase + "/assets/large-trash-can@3x.png",
  "atticusLogo@1x": imageUrlBase + "/assets/Atticus.png",
  "atticusLogo@1.5x": imageUrlBase + "/assets/Atticus-1.5x.png",
  "atticusLogo@2x": imageUrlBase + "/assets/Atticus-2x.png",
  "atticusLogo@3x": imageUrlBase + "/assets/Atticus-3x.png",
  atticusLogo: imageUrlBase + "/assets/atticus-logo.svg",
  tsgPartnershipLogo: imageUrlBase + "/advisor-groups/trustee-services-group/tsg-partnership.svg",
  tsgPartnershipAltLogo:
    imageUrlBase + "/advisor-groups/trustee-services-group/tsg-partnership-dark-background.svg",
  tsgPartnershipSecondary:
    imageUrlBase + "/advisor-groups/trustee-services-group/tsg-partnership-secondary.svg",
  tsgPartnershipSecondaryAlt:
    imageUrlBase +
    "/advisor-groups/trustee-services-group/tsg-partnership-secondary-dark-background.svg",
  guwPartnershipLogo: imageUrlBase + "/advisor-groups/green-up-wealth/guw-partnership.svg",
  guwPartnershipAltLogo:
    imageUrlBase + "/advisor-groups/green-up-wealth/guw-partnership-dark-background.svg",
  guwPartnershipSecondary:
    imageUrlBase + "/advisor-groups/green-up-wealth/guw-partnership-secondary.svg",
  guwPartnershipSecondaryAlt:
    imageUrlBase + "/advisor-groups/green-up-wealth/guw-partnership-secondary-dark-background.svg",

  ksbPartnershipLogo: imageUrlBase + "/advisor-groups/ks-bank/ksb-partnership.svg",
  ksbPartnershipAltLogo:
    imageUrlBase + "/advisor-groups/ks-bank/ksb-partnership-dark-background.svg",
  ksbPartnershipSecondary:
    imageUrlBase + "/advisor-groups/ks-bank/ksb-partnership-secondary.svg",
  ksbPartnershipSecondaryAlt:
    imageUrlBase +
    "/advisor-groups/ks-bank/ksb-partnership-secondary-dark-background.svg",


  "noImage@1x": imageUrlBase + "/icons/assets/no-image@1x.png",
  "noImage@2x": imageUrlBase + "/icons/assets/no-image@2x.png",
  "noImage@3x": imageUrlBase + "/icons/assets/no-image@3x.png",
  "add@1x": imageUrlBase + "/icons/assets/add@1x.png",
  "add@2x": imageUrlBase + "/icons/assets/add@2x.png",
  "add@3x": imageUrlBase + "/icons/assets/add@3x.png",
  "household@1x": imageUrlBase + "/icons/assets/household@1x.png",
  "household@2x": imageUrlBase + "/icons/assets/household@2x.png",
  "household@3x": imageUrlBase + "/icons/assets/household@3x.png",
  "realestate@1x": imageUrlBase + "/icons/assets/realestate@1x.png",
  "realestate@2x": imageUrlBase + "/icons/assets/realestate@2x.png",
  "realestate@3x": imageUrlBase + "/icons/assets/realestate@3x.png",
  "primaryhome@1x": imageUrlBase + "/icons/assets/primaryhome@1x.png",
  "primaryhome@2x": imageUrlBase + "/icons/assets/primaryhome@2x.png",
  "primaryhome@3x": imageUrlBase + "/icons/assets/primaryhome@3x.png",
  "rentalproperty@1x": imageUrlBase + "/icons/assets/rentalproperty@1x.png",
  "rentalproperty@2x": imageUrlBase + "/icons/assets/rentalproperty@2x.png",
  "rentalproperty@3x": imageUrlBase + "/icons/assets/rentalproperty@3x.png",
  "investmentproperty@1x": imageUrlBase + "/icons/assets/investmentproperty@1x.png",
  "investmentproperty@2x": imageUrlBase + "/icons/assets/investmentproperty@2x.png",
  "investmentproperty@3x": imageUrlBase + "/icons/assets/investmentproperty@3x.png",
  "vacationhome@1x": imageUrlBase + "/icons/assets/vacationhome@1x.png",
  "vacationhome@2x": imageUrlBase + "/icons/assets/vacationhome@2x.png",
  "vacationhome@3x": imageUrlBase + "/icons/assets/vacationhome@3x.png",
  "contracts@1x": imageUrlBase + "/icons/assets/contracts@1x.png",
  "contracts@2x": imageUrlBase + "/icons/assets/contracts@2x.png",
  "contracts@3x": imageUrlBase + "/icons/assets/contracts@3x.png",
  "financial@1x": imageUrlBase + "/icons/assets/financial@1x.png",
  "financial@2x": imageUrlBase + "/icons/assets/financial@2x.png",
  "financial@3x": imageUrlBase + "/icons/assets/financial@3x.png",
  "vehicle@1x": imageUrlBase + "/icons/assets/vehicle@1x.png",
  "vehicle@2x": imageUrlBase + "/icons/assets/vehicle@2x.png",
  "vehicle@3x": imageUrlBase + "/icons/assets/vehicle@3x.png",
  "digital@1x": imageUrlBase + "/icons/assets/digital@1x.png",
  "digital@2x": imageUrlBase + "/icons/assets/digital@2x.png",
  "digital@3x": imageUrlBase + "/icons/assets/digital@3x.png",
  "other@1x": imageUrlBase + "/icons/assets/other@1x.png",
  "other@2x": imageUrlBase + "/icons/assets/other@2x.png",
  "other@3x": imageUrlBase + "/icons/assets/other@3x.png",
  "alert@1x": imageUrlBase + "/icons/assets/alert@1x.png",
  "alert@2x": imageUrlBase + "/icons/assets/alert@2x.png",
  "alert@3x": imageUrlBase + "/icons/assets/alert@3x.png",
  "purpleBlob@1x": imageUrlBase + "/blob-icons/blob-purple-1x.png",
  "purpleBlob@1.5x": imageUrlBase + "/blob-icons/blob-purple-1.5x.png",
  "purpleBlob@2x": imageUrlBase + "/blob-icons/blob-purple-2x.png",
  "purpleBlob@3x": imageUrlBase + "/blob-icons/blob-purple-3x.png",
  "blueBlob@1x": imageUrlBase + "/blob-icons/blob-blue-1x.png",
  "blueBlob@1.5x": imageUrlBase + "/blob-icons/blob-blue-1.5x.png",
  "blueBlob@2x": imageUrlBase + "/blob-icons/blob-blue-2x.png",
  "blueBlob@3x": imageUrlBase + "/blob-icons/blob-blue-3x.png",
  "greenBlob@1x": imageUrlBase + "/blob-icons/blob-green-1x.png",
  "greenBlob@1.5x": imageUrlBase + "/blob-icons/blob-green-1.5x.png",
  "greenBlob@2x": imageUrlBase + "/blob-icons/blob-green-2x.png",
  "greenBlob@3x": imageUrlBase + "/blob-icons/blob-green-3x.png",
  "purpleFolder@1x": imageUrlBase + "/folder-icons/folder-large-purple-1x.png",
  "purpleFolder@1.5x": imageUrlBase + "/folder-icons/folder-large-purple-1.5x.png",
  "purpleFolder@2x": imageUrlBase + "/folder-icons/folder-large-purple-2x.png",
  "purpleFolder@3x": imageUrlBase + "/folder-icons/folder-large-purple-3x.png",
  "blueFolder@1x": imageUrlBase + "/folder-icons/folder-large-blue-1x.png",
  "blueFolder@1.5x": imageUrlBase + "/folder-icons/folder-large-blue-1.5x.png",
  "blueFolder@2x": imageUrlBase + "/folder-icons/folder-large-blue-2x.png",
  "blueFolder@3x": imageUrlBase + "/folder-icons/folder-large-blue-3x.png",
  "greenFolder@1x": imageUrlBase + "/folder-icons/folder-large-green-1x.png",
  "greenFolder@1.5x": imageUrlBase + "/folder-icons/folder-large-green-1.5x.png",
  "greenFolder@2x": imageUrlBase + "/folder-icons/folder-large-green-2x.png",
  "greenFolder@3x": imageUrlBase + "/folder-icons/folder-large-green-3x.png",
  "helpDrawerHeader@1x": imageUrlBase + "/images/help-drawer-header-1x.png",
  "helpDrawerHeader@2x": imageUrlBase + "/images/help-drawer-header-2x.png",
}

export const assetIcons: { [key: string]: JSX.Element } = {
  Household: (
    <img
      srcSet={`${imageUrls["household@2x"]} 2x, ${imageUrls["household@3x"]} 3x`}
      src={`${imageUrls["household@1x"]}`}
      alt="Household"
    />
  ),
  Financial: (
    <img
      srcSet={`${imageUrls["financial@2x"]} 2x, ${imageUrls["financial@3x"]} 3x`}
      src={`${imageUrls["financial@1x"]}`}
      alt="Financial"
    />
  ),
  // "Annuities": <></>,
  // "Cash": <></>,
  // "CD's or other Certificates": <></>,
  // "Investments": <></>,
  // "Insurance Policies": <></>,
  // "Retirement Accounts": <></>,
  // "Social Security Statements": <></>,
  // "Other": <></>,
  // "Checking": <></>,
  // "Savings": <></>,
  // "Loan": <></>,
  // "Credit Card": <></>,
  // "Line of Credit": <></>,
  // "Mortgage": <></>,
  // "Property": <></>,
  // "Prepaid": <></>,
  // --------------------------
  "Real Estate": (
    <img
      srcSet={`${imageUrls["realestate@2x"]} 2x, ${imageUrls["realestate@3x"]} 3x`}
      src={`${imageUrls["realestate@1x"]}`}
      alt="Real Estate"
    />
  ),
  "Investment property (developed/undeveloped)": (
    <img
      srcSet={`${imageUrls["investmentproperty@2x"]} 2x, ${imageUrls["investmentproperty@3x"]} 3x`}
      src={`${imageUrls["investmentproperty@1x"]}`}
      alt="Investment"
    />
  ),
  "Primary Home": (
    <img
      srcSet={`${imageUrls["primaryhome@2x"]} 2x, ${imageUrls["primaryhome@3x"]} 3x`}
      src={`${imageUrls["primaryhome@1x"]}`}
      alt="Primary"
    />
  ),
  "Rental Properties": (
    <img
      srcSet={`${imageUrls["rentalproperty@2x"]} 2x, ${imageUrls["rentalproperty@3x"]} 3x`}
      src={`${imageUrls["rentalproperty@1x"]}`}
      alt="Rental"
    />
  ),
  // "Time Share": <></>,
  "Timber,Solar, Mineral Interest contracts": (
    <img
      srcSet={`${imageUrls["contracts@2x"]} 2x, ${imageUrls["contracts@3x"]} 3x`}
      src={`${imageUrls["contracts@1x"]}`}
      alt="Contracts"
    />
  ),
  "Vacation home": (
    <img
      srcSet={`${imageUrls["vacationhome@2x"]} 2x, ${imageUrls["vacationhome@3x"]} 3x`}
      src={`${imageUrls["vacationhome@1x"]}`}
      alt="Vacation home"
    />
  ),
  // --------------------------
  Vehicles: (
    <img
      srcSet={`${imageUrls["vehicle@2x"]} 2x, ${imageUrls["vehicle@3x"]} 3x`}
      src={`${imageUrls["vehicle@1x"]}`}
      alt="Vehicle"
    />
  ),
  // Boats: <></>,
  // Cars: <></>,
  // "Lawn Mowers, Tractors, etc.": <></>,
  // Trailers: <></>,
  // --------------------------
  Digital: (
    <img
      srcSet={`${imageUrls["digital@2x"]} 2x, ${imageUrls["digital@3x"]} 3x`}
      src={`${imageUrls["digital@1x"]}`}
      alt="Digital"
    />
  ),
  // --------------------------
  Other: (
    <img
      srcSet={`${imageUrls["other@2x"]} 2x, ${imageUrls["other@3x"]} 3x`}
      src={`${imageUrls["other@1x"]}`}
      alt="Other"
    />
  ),

  // "Misc" images are the same as "other" images
  Miscellaneous: (
    <img
      srcSet={`${imageUrls["other@2x"]} 2x, ${imageUrls["other@3x"]} 3x`}
      src={`${imageUrls["other@1x"]}`}
      alt="Miscellaneous"
    />
  ),
}
